import Upload from 'components/uploader/upload';

const updateState = (docs, updatedDoc, outlet, internalStateSetter) => {
    internalStateSetter({ doc: updatedDoc })
    const updatedDocs = docs.map((item) => {
        if (item.id === updatedDoc.id) return updatedDoc;
        return item
    })

    outlet({ docs: updatedDocs })
}

const changeUpload = async (file, setter, state, key) => {
    const upload = new Upload(file)
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {

        const updatedDoc = { ...state, [key]:reader.result}
        setter({ doc: updatedDoc })
    };
  

    await upload.upload()
    return { uuid: upload.uuid || null, url: reader.result || ''}
  }

export default {
    'OptionalDoc.Wrapper.OptionalUpload.OptionalWebCamBtn': ({ toggleWebCam, docID }, outlet, internalStateSetter) => {
        outlet({ toggleWebCam: { label: toggleWebCam, docID } })
    },
    'OptionalDoc.Wrapper.OptionalUpload.UploadButton': async ({ value, doc, docs }, outlet, internalStateSetter) => {        
        const { uuid, url }  = await changeUpload(value, internalStateSetter, doc, 'docUrl')
        const updatedDoc = { ...doc, docUrl: url, docID: uuid, docIDError: '', hasError: false }

        updateState(docs, updatedDoc, outlet, internalStateSetter)
    },
    'OptionalDoc.Wrapper.OptionalUpload.UploadedImage': ({ doc, docs }, outlet, internalStateSetter) => {
        const updatedDoc = { ...doc, docUrl: '', docID: '' }
        updateState(docs, updatedDoc, outlet, internalStateSetter)
    },
    'OptionalDoc.Wrapper.DeleteButton': ({ id, docs }, outlet, internalStateSetter) => {
        const filteredDocuments = docs.filter((doc) => doc.id !== id)
        outlet({ docs: filteredDocuments })
    },
}
